import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'
import Helmet from 'react-helmet'

/*import { Timeline } from 'react-twitter-widgets' */

import portrait from '../img/cw.jpg';
import divider1 from '../img/bg/divider1.jpg';

class HeaderComplete extends React.Component {
  render() {
    /* console.log("props", this.props)
     const pageLinks = []
     const site = get(this, 'props.data.site.siteMetadata') */
    return (
		<div id="headerwrap" name="home" style={{backgroundImage: 'url(' + divider1 + ')' }} >
			<header className="clearfix">
				<h1><span className="icon icon-w"></span></h1>
				<p>Christian Wolter</p>
			</header>
		</div>
		)
	}
}

let imgStyle = {
	margin: '0px auto'
}

class Footer extends React.Component {
	constructor() {
    super();
    	this.state = {
        intervalId: 0
    };
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
        clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop() {
    let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId: intervalId });
  }
  render () {
      return <div>
				        <div id="footerwrap">
							       <div className="container">
								           <h4><small>created by Christian Wolter - copyright 2019 - <Link to='/imprint' onClick={ () => { this.scrollToTop(); }}>imprint | disclaimer</Link> -  <Link to='/privacy' onClick={ () => { this.scrollToTop(); }}>privacy</Link></small></h4>
							       </div>
						    </div>
				      </div>;
		}
 }

class ScrollButton extends React.Component {
  constructor() {
    super();
    	this.state = {
        intervalId: 0
    };
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
        clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop() {
    let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId: intervalId });
  }

  render () {
      return <button title='Back to top' className='scroll'
               onClick={ () => { this.scrollToTop(); }}>
                <span className='arrow-up glyphicon glyphicon-chevron-up'></span>
              </button>;
   }
}

class PageIndex extends React.Component {
  render() {
    // console.log("props", this.props)
    // const pageLinks = []
    // const site = get(this, 'props.data.site.siteMetadata')
    // const posts = get(this, 'props.data.remark.posts')
    // const sortedPosts = sortBy(posts, post =>
    //   get(post, 'post.frontmatter.date')
    // ).reverse()
		//
    // sortedPosts.forEach((data, i) => {
    //   if (
    //     data.post.frontmatter.layout === 'post' &&
    //     data.post.path !== '/404/'
    //   ) {
    //     pageLinks.push(
    //       <SitePost data={data.post} site={site} isIndex={true} key={i} />
    //     )
    //   }
    // })

    return (
			<div>
				<HeaderComplete />
				<div className="container" id="about" name="about">
						 <div className="row white">
									<br/>
									<h1 className="centered">about me</h1>
						</div>

						<hr/>

						<div className="row white">

									<div className="col-md-5 col-sm-4 col-xs-4">
									</div>

									<div className="col-md-2 col-sm-4 col-xs-4">
										<img src={portrait} alt="CW" className="img-circle img-responsive" style={ imgStyle }/>
									</div>

								 <div className="col-md-5 col-sm-4 col-xs-4">
								 </div>

						</div>

						<div className="row white">

									<div className="col-md-2">
									</div>

									<div className="col-md-8">
												 <p className="centered">Digital native, startup mind, hobbyist programmer<br/>innovation management enthusiast</p>

                        <p className="centered">Born in the 80s in Hanover <small>(Hannover)</small>, Germany<br/>
                           Since 2009 based in Nuremberg <small>(Nürnberg)</small>, Germany</p>
								 </div>

								 <div className="col-md-2">
								 </div>

						</div>

						</div>
				<ScrollButton scrollStepInPx="50" delayInMs="16.66" />
				<Footer/>
			</div>
    )
  }
}

export default PageIndex



// WEBPACK FOOTER //
// ./src/pages/index.js